module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_8003.c11d0186.png";